module.exports = __webpack_public_path__ + "img/hooker-furniture.0977760.jpg";